module.exports = __webpack_public_path__ + "static/img/xuanzhongyinpin.png@2x(1).21807b7d.png";